module.exports = __webpack_public_path__ + "img/llamada.755f9809.png";